import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'
import GlobalConst from '@/globals'

export default { 
  data () {
    return {
      hovering: false
    }
  },
  methods: {
    ...mapMutations('userform', [
      'dropListItem'
    ]),
    dropRow () {
      if (this.listId.uuid && !(this.listId.id)) {
        this.$emit('drop')
      } else {
        if (this.isClient) {
          api.userform.contactUserForm.deleteRow(this.userFormId, this.question.id, this.fieldType.id, this.listId.id)
            .then(() => {
              this.dropListItem({questionId: this.question.id, listId: this.listId.id})
              this.$emit('drop')
            })
        } else {
          api.userform.userForm.deleteRow(this.userFormId, this.question.id, this.fieldType.id, this.listId.id)
            .then(() => {
              this.dropListItem({questionId: this.question.id, listId: this.listId.id})
              this.$emit('drop')
            })
        }
      }
    }
  },
  computed: {
    ...mapGetters('userform', {
      answerObject: 'answer'
    }),
    isEmpty () {
      var emptyAnswer = true
      this.fieldType.subfieldtypes.forEach(subfield => {
        var answer = this.answerObject(this.question.id, subfield.id, this.listId.id) || false
        if (answer && emptyAnswer) {
          emptyAnswer = GlobalConst.TestAnswerEmpty(answer, subfield)
        }
      })
      return emptyAnswer
    }
  }
}
